import React from 'react';
import { Typography } from '@mui/material';

const GeneralSettingsJoyrideContent = () => {
    return (
        <>
            <Typography variant='body2' align='left' gutterBottom>Customize video settings.</Typography>
            <Typography variant='body2' align='left' gutterBottom>
                <b>AUDIO</b>: Upload an MP3, WAV, or AAC file to be used in the video.
                If the audio is not synced with the preview, it may be because the audio file has a variable bit rate (VBR).
                For best results use audio with a constant bit rate (CBR).
                Regardless of the bit rate, the audio will be correctly synced when exporting.
            </Typography>
            <Typography variant='body2' align='left' gutterBottom>
                <b>IMAGES</b>: Upload images to be used in the video.
                The logo image will appear in the middle of the visualizer where the Specterr logo appears by default.
            </Typography>
            <Typography variant='body2' align='left' gutterBottom>
                <b>PRESET</b>: Pick from a selection of presets / templates to get a starting point for the video.
                Applying a preset will not overwrite any uploaded images or changed text.
            </Typography>
            <Typography variant='body2' align='left' gutterBottom>
                <b>TEXT</b>: Edit the video text.
            </Typography>
            <Typography variant='body2' align='left' gutterBottom>
                <b>COLORS</b>: Change the visualizer colors.
                The fill color of each wave layer can be changed.
                And if the wave layer has an outline or secondary color, that can be changed too.
                A secondary color is a color that the layer will change into during loud noises.
            </Typography>
        </>
    );
}

export default GeneralSettingsJoyrideContent;
